import ImageObject from './ImageObject'

export default class ImageContainer
{

  static getInstance() {
    return this.instance ? this.instance : this.instance = new ImageContainer();
  }

  constructor() {
    this.images = {};
  }

  image(url) {

    if (this.images.hasOwnProperty(url)) {
      return this.images[url];
    }

    return this.images[url] = new ImageObject(url);

  }

}
